import React from 'react';
import { createPortal } from 'react-dom';
import AppointmentEditForm from './AppointmentEditForm';
import { useEscapeKey } from '../../hooks/useEscapeKey';

interface AppointmentEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  appointmentId: string;
  onSuccess?: (appointment?: any) => void;
}

const AppointmentEditModal: React.FC<AppointmentEditModalProps> = ({
  isOpen,
  onClose,
  appointmentId,
  onSuccess
}) => {
  useEscapeKey(onClose, isOpen);
  
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[500] overflow-hidden">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-30 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal Panel */}
      <div className="absolute inset-y-0 right-0 flex max-w-xl w-full">
        <div className="bg-white w-full shadow-2xl">
          <AppointmentEditForm 
            appointmentId={appointmentId}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AppointmentEditModal;

